
@switch (definition.type) {
  @case ('span') {
    <span>
      <ng-container *ngTemplateOutlet="template"></ng-container>
    </span>
  }
  @default {
    <div>
      <ng-container *ngTemplateOutlet="template"></ng-container>
    </div>
  }
}

<ng-template #template>
  @for (child of definition.definitions; track child) {
    @if (definition.visible | booleanRule: value:true) {
      <div
        [ngClass]="child.class | classRule: value"
        >
        @if (child.title) {
          <label
            class="soft-label"
            [ngClass]="(child.titleClass | classRule: value) || 'left'"
            >{{ child.title }}</label
            >
          }
          <soft-dynamic-value
            [definition]="child"
            [value]="value"
          ></soft-dynamic-value>
        </div>
      }
    }
  </ng-template>
